module.exports = "/assets/js/5b89e156f49f8f6b3af5bc257770e73d.svg";